export default {
  home: {
    describe1: "ご利用を歓迎します",
    describe2: "世界を指先の距離だけにしました",
    describe3: "完全なクロスプラットフォームソリューションは、ネットワークプラットフォームに基づいて、分散型エリア管理技術を使用して、効果的に統合することができますさまざまなマルチメディアリソースは、リモート番組の製作、配信、管理を実現します。"
  },
  app: {
    more: "もっと調",
    LogOut: "ログアウト",
    AddMaterial: "素材を追加",
    CreateRelease: "新設発表",
    AddTerminal: "端末を追加",
    CreateAccount: "アカウントを新設します",
    Percent: "ダウンロード進捗状況です",
    ReleaseSchedule: "進捗を発表",
    retransmission: "再送",
    AllRetransmission: "すべてを再送",
    ClearanceToComplete: "除去完了",
    RemoveAll: "すべてを一掃"
  },
  basics: {
    Cancel: "とり消",
    Confirm: "確か",
    en: "英語",
    zh: "中文",
    PleaseSelect: "選択してください",
    PleaseInput: "内容を入力してください",
    materialCatalogue: "素材リスト",
    structureGrouping: "グルーピング",
    inStreamType: "中間タイプ"
  },
  public: {
    search: "検索キーワードを入力していただきます。"
  },
  router: {
    help: "ヘルプ",
    material: "素材管理",
    programme: "番組管理",
    editProgramme: "番組編集",
    publishProgramme: "プレミアムリリース",
    terminal: "端末管理",
    check: "審査管理",
    log: "ログ管理",
    logLogin: "ログを登録",
    logOperation: "操作履歴",
    logTerminal: "端末ログ",
    seniorManagement: "高度な管理",
    userManage: "ユーザー管理",
    RoleManage: "役割管理",
    systemLayout: "システム設定",
    nodeManage: "ノード管理",
    reviewSet: "設定を見直",
    softwareLicence: "ソフトウェアライセンスです"
  },
  device: {},
  explorer: {
    clickUpload: "書類をここまで引っ張ってきます，または<em>アップロードをクリックします</em>",
    sizeLimit: "单文件不超过",
    video: "ビデ",
    picture: "画像",
    uploadFiles: "ファイルをアップロードします",
    newFolder: "新規フォルダ作成",
    deleteFiles: "ファイルを削除",
    materialAll: "全ての素材をロードしました",
    materialsLoaded: "クリックしてより多くのネタをロード",
    move: "移動",
    copy: "複製",
    delete: "削除",
    all: "全選",
    name: "名前",
    resolution: "解像度",
    fileSize: "ファイルサイズ",
    creationTime: "作成時間",
    operate: "操作",
    FolderName: "フォルダ名",
    deleteFile: "現在選択しているファイルを削除しますか?",
    BackEdit: "番組編集に戻",
    FileMove: "ファイル移動",
    FileCopy: "ファイルコピー",
    StartAll: "全て開始",
    StopAll: "すべて停止",
    EmptyFinish: "クリア完了",
    CancelAll: "全部キャンセル",
    NoFiles: "仮無上伝書",
    Status: "状態",
    Check: "調べ",
    Stop: "停止",
    Start: "始め",
    Cancel: "取り消",
    finish: "完成"
  },
  log: {
    export: "導出",
    selectDevice: "デバイスを選択",
    deviceSn: "デバイスSN",
    operateTime: "作業時間",
    operateUser: "ユーザーを操作",
    function: "機能",
    describe: "記述",
    dateArr: "期日の範囲",
    startDate: "開始日",
    endDate: "終了期日",
    search: "照会",
    searchTips: "お問い合わせはデバイスを1台お願いします",
    loadingTips: "ログ取得中です。少々お待ちください。",
    no: "番号",
    content: "中身",
    operateObj: "操作対象",
    operateContent: "操作情報",
    selectTips1: "3ヶ月以内のデータ照会にのみ対応します。",
    searchTips1: "一台の端末を選択し、時間帯を決め、問い合わせをお願いします",
    exportTips: "クエリ時間範囲のデータしか導き出せません"
  },
  login: {
    Login: "登録",
    memberRegister: "すぐに登録",
    ForgetThePassword: "パスワードを忘れましたか?",
    NoLogin: "7日間は登録が免除",
    verification: "captcha入力をお願い",
    account: "口座の入力をお願い",
    password: "パスワードをお願い"
  },
  manage: {},
  review: {
    Screenshot: "スクリーンショット",
    ProgramName: "番組名",
    Structure: "組織構造",
    Resolution: "解像度",
    CreationTime: "作成時間",
    operate: "操作",
    Review: "監査",
    Check: "見る",
    ProgramMaterial: "番組素材",
    ProgramPreview: "番組のプレビュー",
    ReviewContent: "レビュー内容を入力してください",
    Approved: "審査に合格する",
    RejectReview: "通過拒否",
    DeleteAll: "すべて削除を確認しますか？",
    Name: "名前",
    Size: "サイズ",
    Preview: "プレビュー",
    ProgramReview: "番組レビュー",
    ReasonRefusal: "拒否理由をご記入ください！",
    number: "リリース番号が選択されていない",
    review: "審査",
    enterKey: "キーワード入力お願い",
    screenshot: "スクリーンショット",
    name: "名前",
    group: "機構",
    createTime: "提出時期",
    publisher: "発信者",
    check: "調べ",
    pass: "通過しました",
    reject: "お断り",
    materialCheck: "素材審査",
    pleaseInputContent: "審査内容の入力をお願い",
    approve: "審査に合格",
    rejectReview: "審査を拒否",
    releaseReview: "審査を行います",
    resonForReject: "拒絶理由の入力をお願いします。",
    all: "全部",
    waitReview: "審査待ち",
    approves: "通過",
    selectTips: "最低でも素材を1つお願い",
    selectTips1: "登録番号を選択していません",
    deleteTips: "全削除確認ですか?",
    deleteRecord: "記録を削除",
    singleNo: "単番号",
    loop: "ループ",
    timming: "タイミング",
    instream: "中継",
    noAdap: "非適応",
    adap: "適応画面サイズ"
  },
  schedule: {
    Screenshot: "スクリーンショット",
    ProgramName: "番組名",
    Structure: "組織構造",
    Resolution: "解像度",
    CreationTime: "作成時間",
    operate: "操作",
    AllLoaded: "すべての素材がロードされました",
    materialsLoaded: "クリックしてもっと素材を読み込む",
    NewProgram: "新しいプログラム+",
    DelProgram: "現在選択されている番組を永久に削除しますか？",
    DeleteMedia: "メディアの削除",
    loop: "ループ再生",
    timpingPlay: "タイミングプレイ",
    emerPlay: "緊急中継",
    releaseRecord: "リリース記録",
    releaseMan: "リリース管理",
    playNo: "リリース番号",
    group: "機構",
    releaseType: "パブリッシュ",
    releaseNow: "今すぐリリース",
    releaseTim: "リリース時間",
    publisher: "投稿者",
    review: "監査",
    pedReview: "審査待ち",
    noReview: "レビューなし",
    noPass: "不合格",
    pass: "通過した",
    waitRelease: "公開予定",
    expird: "失効しました",
    detail: "詳細",
    delete: "削除",
    deletePlay: "番組を削除する",
    deletePlayTip: "現在選択されている番組を永久に削除しますか？",
    keyWords: "キーワードを入力して",
    noSelectTip: "パブリッシュレコードが選択されていない",
    addPlay: "プログラムの追加",
    selectProgram: "プログラムの選択",
    delPro: "番組を削除する",
    delProTip: "すべての番組をクリアしますか？",
    screenshot: "スクリーンショット",
    proName: "プログラム名",
    structure: "組織構造",
    resolution: "解像度",
    createTime: "作成時間",
    noProgram: "現在番組はありません",
    moveDown: "これ以上下に移動できない",
    moveUp: "もう上に移動できない",
    tips: "ヒント",
    playList: "プレイリスト",
    terminalList: "ターミナルリスト",
    releaseProp: "パブリッシュプロパティ",
    offline: "オフライン",
    timimgPlan: "タイミングリリース",
    user: "ユーザー",
    terminalName: "ターミナル名",
    terminalState: "デバイスステータス",
    publishSate: "公開ステータス",
    planModole: "再生モード",
    playStrategy: "リリースポリシー",
    playPlan: "プレイプラン",
    playCount: "再生回数",
    playsCount: "連続再生回数",
    pleaseSelect: "選択してください",
    playTimes: "再生時間",
    conPlayTime: "連続再生時間",
    publish: "リリース",
    customize: "カスタム化",
    once: "一度",
    twice: "2回",
    treeTimes: "三回",
    fourTimes: "四回",
    fiveTimes: "5回",
    sixTimes: "六回",
    sevenTimes: "七回",
    eightTimes: "八回",
    nineTimes: "九回",
    tenTimes: "十回",
    countTips: "最低回数は1",
    pubSuccessTip: "パブリッシュ成功",
    selectTip1: "少なくとも2番組を選択してください",
    planPre: "番組のプレビュー",
    addPlayStep: "スケジュールの追加ステップ",
    selectDate: "日付と時間の選択",
    instreamResver: "予約ブロック",
    instreamNow: "すぐに挿入する",
    selectTimeTips: "選択した時刻は現在の時刻より小さい時刻ではありません",
    palyTime: "再生時間",
    selectStartTime: "開始時間の選択",
    selectEndTime: "終了時間の選択",
    conserLoop: "連続サイクル回数",
    validDate: "有効日",
    date: "日付",
    daily: "毎日",
    startTimeTips: "開始時間は終了時間より遅くはできません",
    endTimeTips: "終了時間は開始時間より早くはできません",
    startDateTips: "開始日は終了日より遅くはできません",
    endDateTips: "終了日は開始日より早くはできません",
    saveAplan: "少なくとも1つの計画を保持する",
    check: "見る",
    planSize: "プログラムサイズ",
    planName: "リリース名",
    leastTime: "有効期限"
  },
  system: {
    StructureName: "組織名",
    Operate: "操作",
    NewStructure: "組織構造の追加",
    DeleteStructure: "組織構造の削除",
    Structure: "組織構造",
    MsgDeleteStructure: "現在を永久に削除しますか？",
    OnDevice: "デバイスのオン",
    OffDevice: "デバイスのシャットダウン",
    inquiry: "欲しいかどうかすみません",
    on: "オン",
    off: "閉じる",
    slaveDevice: "現在またはスレーブデバイス",
    CloseCurrent: "現在を閉じる",
    CloseSlave: "スレーブを閉じる",
    OpenCurrent: "現在を開く",
    OpenSlave: "オンスレーブ",
    Account: "口座番号",
    Name: "名前",
    Role: "役割",
    Grade: "グレード",
    Remark: "備考",
    RoleName: "ロール名",
    Password: "パスワード",
    ConfirmPass: "パスワードの確認",
    Mail: "郵箱",
    DeleteUser: "ユーザーの削除",
    DeleteRole: "現在のロールを永久に削除しますか？",
    UnblockDevice: "開封装置",
    banDevice: "禁止装置",
    Unblock: "ブロック解除",
    ban: "封じる",
    BanTheCurrent: "現在を禁止する",
    BannedAffiliate: "従属を封じる",
    ReleaseTheCurrent: "解禁現在",
    ReleaseTheSubordinate: "従属を解禁する",
    AddUser: "ユーザーの追加",
    ModifyUser: "ユーザーの変更",
    inputPassword: "確認パスワードを入力してください",
    noPassword: "2回入力したパスワードが一致しない！",
    inputName: "名前を入力してください",
    RoleEmpty: "ロール名は空にできません",
    StructureEmpty: "組織構造は空にできません",
    AccountEmpty: "アカウントは空に許可されません",
    AccountAstrict: "アカウントには数字、アルファベット、アンダースコアしか入れられません！",
    AccountLength: "アカウントの長さを3~20文字に設定してください！",
    AccountRegistered: "現在のアカウントは登録されていますので、再入力してください！",
    AddRole: "キャラクターの追加",
    RoleRemark: "キャラクターメモ",
    RightConfig: "権限設定",
    DelRole: "ロールの削除",
    imageSize1: "推奨サイズ920x940ピクセルのPNGフォーマットの画像",
    ReplacePicture: "画像を置き換える",
    LoginLogo: "ログインページLOGO",
    imageSize2: "推奨サイズ360x80ピクセルのPNGフォーマットの画像",
    SystemLogo: "システムページLOGO",
    systemSettings: "その他のシステム設定",
    configInformation: "その他の構成情報",
    DailyLimit: "1日の申込上限",
    UploadedType: "アバター画像のアップロードはPNG形式のみです",
    UploadedSize: "アップロードされたアバター画像のサイズは2MBを超えてはいけません！",
    addNode: "ノードの追加",
    EnglishName: "英語名",
    ChineseName: "中国語名",
    delNode: "現在のノードを永久に削除しますか。",
    AuthorizationType: "認証コードの種類",
    Model: "モデル",
    Date: "日付",
    AuthorizationCode: "認証コード",
    clearTips1: "現在の監査人をクリアしますか。",
    clearTips2: "現在の審査人員を空にしますか?",
    selectReviewer: "レビュー者の選択",
    noReviers: "関連する監査権限を持たない人",
    createTips: "まず審査アカウントを作成してください",
    sameReviwers: "次の機関が同じ監査員を共有する",
    email: "メール",
    phone: "電話",
    lastLogin: "最後のログイン",
    remark2: "企業住所",
    resetPwd: "パスワードのリセット",
    subUser: "下部ユーザー",
    NumOfTerminals: "端末数",
    NumOfPro: "番組数",
    editPwd: "パスワードの変更",
    oriPwd: "元のパスワード",
    newPwd: "パスワードの新規設定",
    confirmPws: "パスワードの確認",
    modifyInfo: "情報の変更",
    changeNick: "ニックネームの変更",
    changeEmail: "メールボックスの変更",
    personalCenter: "パーソナルセンター",
    enterOriPwd: "元のパスワードを入力してください",
    enterNewPwd: "新しいパスワードを入力してください",
    confirmPwd: "パスワードを確認してください",
    enterNick: "ニックネームを入力してください",
    pwdNoPass: "2回のパスワードが一致しない",
    changePwdSucc: "パスワード変更に成功",
    modiSuccess: "修正に成功",
    modiFail: "修正失敗",
    noSet: "設定されていない",
    PleaseInputEmail: "メールをお願いします。"
  },
  terminal: {
    treeTitle: "組織構造グループ化",
    Details: "詳細",
    online: "オンライン",
    offline: "オフライン",
    list: "リスト",
    card: "グラフ",
    map: "地図",
    keyWord: "キーワードを入力してください",
    refresh: "刷新",
    add: "追加",
    delete: "削除",
    deviceName: "デバイス名",
    remark: "備考",
    resolution: "解像度",
    types: "タイプ",
    version: "バージョン数",
    status: "状態",
    operate: "操作",
    edit: "修正",
    loading: "必死にロード中",
    allSelect: "スプレッドすべて選択",
    selected: "選択済み",
    selectAll: "このページのすべてを選択",
    selectInMap: "地図上で設備の場所を選択してください",
    structure: "組織構造",
    selectGroup: "組織構造を選択してください",
    selectSize: "解像度を選択してください",
    customize: "カスタム化",
    followTerminal: "端末に従う",
    selectSn: "SNを選択してください",
    deviceTip: "デバイス名は空にできません",
    snTip: "SNを空にすることはできません",
    sizeTip: "画面解像度を空にすることはできません",
    deviceType: "デバイスタイプ",
    cancel: "取り消す",
    confirm: "確定",
    delDevice: "端末の削除",
    delDevTip: "選択した端末を永久に削除しますか？",
    onlineTotal: "オンライン統計",
    reboot: "再起動",
    offscreen: "画面を閉じる",
    onscreen: "スクリーンを開く",
    timeTask: "タイミング命令",
    conBright: "明るさ調整",
    conVoice: "音調整",
    relay: "リレースイッチ",
    timeZone: "タイムゾーン校正",
    signalChange: "信号切り替え",
    synScreen: "マルチスクリーン同期",
    timePlay: "タイミング再生スイッチ",
    timeOn: "タイミングオンオフ",
    wTip: "解像度Wが空",
    hTip: "解像度Hは空",
    xTip: "位置Xが空",
    yTip: "位置Yが空",
    mapTip: "地図を縮小して表の情報を確認してください！！！",
    selectTip: "デバイスが選択されていない",
    deviceDetail: "装置の詳細",
    playList: "プレイリスト",
    affi: "所属機関：",
    screenType: "画面タイプ",
    boxTime: "ボックスクロック",
    noData: "データがありません",
    currTimeZone: "現在のタイムゾーン",
    deviceLan: "デバイス言語",
    deviceZoom: "メモリスペース",
    runState: "実行状態",
    runTime: "連続運転",
    lastHeart: "最近の心拍数",
    timeOrder: "タイミング命令",
    comAddr: "サーバーアドレス",
    voice: "音",
    birght: "明るさ",
    no: "シリアル番号",
    proName: "番組名",
    power: "リレー",
    milRefresh: "秒で自動更新",
    viewPho: "オリジナル画像を見る",
    setTimeZone: "タイムゾーンの設定",
    terminalUp: "ターミナルのアップグレード",
    upType: "アップグレード方式",
    cloudUp: "クラウドアップグレード",
    localUp: "ローカルファイルのアップグレード",
    clickUp: "アップロードをクリックします",
    name: "名前",
    type: "モデル",
    verInfo: "バージョン情報",
    schedule: "進捗",
    noUp: "アップグレード不要",
    waitStar: "開始を待つ",
    downExc: "ダウンロード異常",
    downOK: "ダウンロード成功",
    upTip: "アップグレード中、完了すると自動的に再起動",
    erroBack: "異常フィードバック",
    downError: "ダウンロード失敗",
    dowNum: "1台選択済み",
    upTips1: "注：データ損失を防ぐために、バックアップデータに注意してください、アップグレード完了デバイスは自動的に再起動し、アップグレードプロセス中、",
    upTips2: "電源を切らないでください",
    upGr: "升級",
    serverAddEdit: "サーバーアドレスの変更",
    serEdTit: "この端末を新しいサーバに移行する",
    newAddr: "新しいサーバーアドレス",
    test: "テスト",
    user: "口座番号",
    psw: "パスワード",
    remove: "移行",
    conRes: "再起動の確認",
    conOnSc: "スクリーンの開始を確認する",
    upTips3: "zipまたはapkファイルを使用してください",
    testOk: "テストに合格",
    testFail: "テスト失敗",
    inputTips1: "ユーザー名とパスワードをご記入ください",
    opOk: "操作成功",
    mapTip1: "地図上に装置の位置をマークしてください",
    addDetail: "詳細住所",
    lng: "経度",
    lat: "緯度",
    matTip2: "アドレスの取得に失敗しました。後で試してください",
    orderTip: "選択した端末を再起動しますか？",
    orderTip1: "選択した端末画面を閉じますか？",
    orderTip2: "選択した端末画面をオンにしますか？",
    scSetting: "スケジュール設定",
    selectTip1: "選択してください",
    selectTip2: "タイミングコマンドを追加",
    selectTip3: "テンプレート操作データを選択してください",
    conOrder: "操作指示",
    action1: "番組切り替え",
    action2: "明るさ調整",
    action3: "音量調整",
    action4: "画面を閉じる",
    action5: "スクリーンを開く",
    action6: "信号源切り替え",
    action7: "リレーオフ",
    action8: "リレーオン",
    action9: "画面を閉じる",
    action10: "画面を開く",
    value: "値",
    acVa1: "HDMIファースト",
    acVa2: "非同期信号",
    acVa3: "同期信号",
    excTime: "実行時間",
    dateOk: "有効日",
    noLimit: "無制限",
    isWeekLi: "有効週",
    oper: "操作",
    newTem: "テンプレートの作成",
    savTem: "テンプレートの保存",
    addTem: "スケジュールテンプレートの追加",
    temName: "テンプレート名",
    temTip1: "テンプレート名を入力してください",
    relayOn: "リレースイッチ",
    timeZoneSe: "タイムゾーンの選択",
    hdmiSi: "HDMIソース",
    inSin: "内部信号源",
    openMulti: "マルチスクリーン同期再生を有効にする",
    gps: "GPS同期",
    localW: "LAN同期",
    closeScreen: "マルチスクリーン同期再生をオフにする",
    openTimePlay: "タイミング再生をオンにする",
    closeTimePlay: "タイミング再生をオフにする",
    openTime: "オンタイミング",
    onTime: "電源投入時間",
    offTime: "シャットダウン時間",
    excDate: "実行日",
    closeTime: "シャットダウンタイミング",
    onlyG: "広告機器のみサポート",
    Sunday: "日曜日",
    Monday: "月曜日",
    Tuesday: "火曜日",
    Wednesday: "水曜日",
    Thursday: "木曜日",
    Friday: "金曜日",
    Saturday: "土曜日",
    noDeviceSelected: "デバイスが選択されていない",
    group: "組織機構",
    onlineNum: "オンライン数量",
    offlineNum: "オフライン数",
    totalNum: "デバイス総数",
    noOrderExc: "まだ実行されていないコマンド",
    createTime: "作成時間",
    orderName: "コマンド名",
    aimDevice: "ターゲットデバイス",
    orderStatus: "コマンドステータス",
    timeOut: "タイムアウトフィードバック",
    excSuccess: "実行成功",
    sent: "送信済み",
    timeOpenNo: "タイミングスイッチ：データなし",
    timeOpen: "タイミングスイッチ：ON",
    deviceOff: "デバイスオフライン",
    timeOpenTip: "スケジュール再生がオンになってい",
    timeCloseTip: "タイミング再生がオフになりました",
    programList: "プログラム一覧",
    playTime: "番組の長さ",
    loop: "ループ再生",
    excSta: "実行基準",
    timingPlay: "タイミングプレイ",
    playCount: "再生回数",
    proDelete: "番組を削除する",
    proDeleteTip: "番組を削除するのは確かですか？",
    timePlayOpenTip: "タイミング再生が正常に開始されました",
    timePlayCloseTip: "タイミング再生が終了しました",
    programChangeTip: "番組切り替え成功",
    programIsPlaying: "番組が流れている",
    powerList: "オンボード電源",
    allOpen: "全開",
    allClose: "オールオフ",
    open: "開く",
    close: "閉じる",
    mulCard: "多機能カード",
    firstChannel: "第一路",
    secondChannel: "第二路",
    thirdChannel: "第三路",
    fourthChannel: "第四路",
    fifthChannel: "第五道",
    sixthChannel: "第六路",
    seventhChannel: "第七路",
    eighthChannel: "第八路",
    syncToTerminal: "端末への同期",
    allOpenTip: "多機能カードのオン/オフを確認しますか？",
    operComman: "操作指示",
    brigValue: "音量",
    method: "方式",
    speDate: "指定日",
    speWeek: "指定曜日",
    isDateLimit: "日付制限かどうか",
    isWeekLimit: "曜日制限かどうか",
    edits: "編集",
    timingOn: "タイミングコマンドオン",
    timingOff: "タイミングコマンドオフ",
    addTimingCom: "タイミング命令の追加",
    ban: "無効化",
    opend: "開く",
    closed: "閉じる",
    timePlayTips: "タイミング再生中、切り替えできません",
    addDevice: "デバイスの追加",
    deviceTypeTip: "デバイスタイプを選択して",
    key: "秘密鍵",
    groupTips: "組織構造は空にできません",
    least: "残っている",
    arrangeTip: "0~100の間を選択してください",
    saveSuccess: "保存に成功",
    tempExit: "テンプレートはすでに存在します。名前を変更して",
    command: "コマンド",
    isSent: "に送信されました",
    execSuccess: "実行成功",
    sented: "送信済み",
    execFail: "タイムアウトフィードバック",
    runStatus: "オンライン&オープンスクリーン&放送中",
    timeLimit: "間隔をお願いします",
    timeLimitTip: "秒,再度操作,残り",
    seconds: "秒",
    EditInstruction: "指令編集",
    AddInstruction: "指令追加"
  },
  PE: {
    Setting: "ライセンスコード",
    Save: "保存",
    Release: "リリース",
    Quit: "出口",
    ExitEditProgram: "終了すると現在編集されている番組が破棄されます",
    DragMaterial: "素材ファイルをここにドラッグしてください",
    SaveWait: "必死にスクリーンショット保存中お待ちください...",
    ProgramList: "プログラム一覧",
    multimedia: "マルチメディア",
    AddMultimedia: "マルチメディアの追加",
    Insert: "現在位置に挿入",
    properties: "ウィンドウ素材のプロパティ",
    materialNull: "ウィンドウに素材を追加して下さい",
    Uploaded: "素材のアップロード",
    AllLoaded: "すべての素材がロードされました",
    materialsLoaded: "クリックしてもっと素材を読み込む",
    Text: "テキスト",
    Digital: "デジタルクロック",
    Analog: "アナログ時計",
    Weather: "天気",
    Timing: "ポジティブタイミング",
    Countdown: "カウントダウン",
    StreamMedia: "ストリーミング",
    RSS: "RSS",
    Window: "ウィンドウ",
    Picture: "画像",
    Video: "ビデオ",
    Delete: "削除",
    Webpage: "ホームページ",
    OneLayerUp: "1段上がる",
    OneLayerDown: "次のレベル",
    Top: "トップレベル",
    Bottom: "最下層",
    Full: "フルスクリーン",
    HorizontalFull: "水平に敷く",
    VerticalFull: "垂直に敷く",
    VerticalDown: "垂直下",
    VerticalMiddle: "垂直中央",
    VerticalTop: "垂直上",
    HorizontalLeft: "水平左",
    HorizontalCenter: "水平中央",
    HorizontalRight: "水平右",
    ProgramName: "番組名",
    Structure: "組織構造",
    DeviceType: "デバイスタイプ",
    Resolution: "解像度",
    CustomResolution: "カスタム解像度",
    Device: "装置",
    SelectDevice: "デバイスを選択してください",
    SelectTerminal: "パブリッシュターミナル",
    TerminalName: "ターミナル名",
    DeviceStatus: "デバイスステータス",
    Offline: "オフライン",
    AdaptiveScreen: "適応画面サイズ再生",
    Tip: "ヒント",
    Thumbnail: "サムネイル",
    Name: "名前",
    version: "Pシリーズデバイスのバージョンは<i style=\"color：red;\">(228)</i>以下で、スケジュールリリースのみをサポートしています。まず番組を保存し、番組管理-高度な公開に移動してタイミング再生を選択し、保存した番組を追加して公開してください。",
    Title: "タイトル",
    TimerMode: "時計方式",
    RelativeTime: "相対時間",
    AbsoluteTime: "絶対時間",
    DisplayMode: "表示モード",
    Day: "日",
    Hour: "時",
    Minutes: "分ける",
    Second: "秒",
    EditStyle: "表示スタイル",
    DisplayUsage: "表示モード",
    ARow: "単行",
    MultiRow: "複数行",
    FontFamily: "フォント設定",
    BackgroundColor: "背景色",
    FontColor: "フォント色",
    PlayTime: "再生時間",
    Describe: "記述テキスト",
    HourMark: "タイムスケール",
    HourHand: "時計",
    MinutesMark: "分標",
    MinutesHand: "分",
    background: "背景",
    secondHand: "秒",
    DateAndDay: "日付曜日",
    Display: "表示",
    SelectTimeZone: "タイムゾーンの選択",
    Scale: "ケール制約",
    ConstrainProportions: "コンストレイントスケール",
    EnterTheAnimation: "入場アニメーション",
    TheEntryTime: "入場時間",
    Data: "日付",
    Time: "時間",
    ChineseCalendar: "旧暦",
    Week: "週間",
    DateFormat: "日付フォーマット",
    Font: "フォント",
    Roll: "ローリング",
    FlipOver: "ページめくる",
    Motionless: "静止",
    RollingDirection: "スクロール方向",
    RollingVelocity: "ローリング速度",
    FromLeftToRight: "左から右へ",
    FromRightToLeft: "右から左へ",
    FromTopToBottom: "上から下へ",
    FromTheBottomUp: "下から上へ",
    Attribute: "プロパティ",
    AttendedMode: "接続方式",
    EndToEnd: "つながる",
    VolumeAdjust: "音量調整",
    Duration: "ビデオの長さ",
    Address: "住所",
    City: "都市",
    Temp: "温度",
    WindPower: "風力",
    Humidity: "湿度",
    DressingIndex: "着衣指数",
    PlayTheWay: "再生方式",
    TimeFormat1: "00:00:00:00",
    TimeFormat2: "00D00H00M00S"
  }
}